import React, { useContext } from 'react';

import { useAccountNumber } from '../../fetchHooks/useAccount';
import type { Account, AccountNumber } from '../../generated-types';
import { isValidAccountPaymentFrom } from '../../services/accountFilters';

type PaymentAccountStateType = { targetFromAccount: Account | undefined };
export const PaymentAccountState = React.createContext<PaymentAccountStateType | undefined>(undefined);

export const usePaymentAccountContext = () => {
    const context = useContext(PaymentAccountState)! as PaymentAccountStateType;
    if (context === undefined) {
        throw new Error('usePaymentAccountContext must be used within PaymentAccountState');
    }

    return context;
};

export const usePaymentFromAccount = (fromAccount: AccountNumber | undefined) => {
    const { data: targetFromAccount } = useAccountNumber(fromAccount);
    return { targetFromAccount: isValidAccountPaymentFrom(targetFromAccount) ? targetFromAccount : undefined };
};
